export const convertToMilliSeconds = (seconds) => {
  const timeInMilliSeconds = seconds * 1000;

  return timeInMilliSeconds;
};
